import { useAuthModalContext } from '../components'

export const useModalState = () => {
  const { open, setOpen, resetModal } = useAuthModalContext()
  const handleClose = () => {
    resetModal()
  }
  return { open, setOpen, handleClose }
}
